import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { WorkloadList } from "./list";
import { Layout } from "../../layout";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { WorkloadCreateInitializer } from "./create/initializer";

const WorkloadRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<WorkloadList />} />
        <Route path={`-create/*`} element={<WorkloadCreateInitializer />} />
      </Routes>
    </Layout>
  );
};

export default WorkloadRoute;
